import React, { useState, useEffect } from "react";
import getAdBackgroundStyles from "~/common/Ads/WebPlusAd/getAdBackgroundStyles";
import { plusLogoLink } from "~/common/Constants/links";
import tracking from "~/Gtm/Tracking/tracking";
import useResizeObserver from "~/ProductDetails/VirtualGrouping/Hooks/useResizeObserver";
const WebPlusShippingAdLoggedOut = () => {
  const [screenSize, setScreenSize] = useState("mobile");
  const {
    width
  } = useResizeObserver();
  useEffect(() => {
    const updateScreenSize = () => {
      if (width < 640) {
        setScreenSize("mobile");
        return;
      }
      if (width < 1024) {
        setScreenSize("tablet");
        return;
      }
      setScreenSize("desktop");
    };
    updateScreenSize();
  }, [width]);
  return <tracking.a href="/plus/" data-track="web-plus-homepage-ad" data-track-ei="web-plus-logged-out-free-trial" data-sentry-element="unknown" data-sentry-component="WebPlusShippingAdLoggedOut" data-sentry-source-file="WebPlusShippingAdLoggedOut.tsx">
      <div className="relative flex flex-row w-full rounded overflow-hidden" style={getAdBackgroundStyles(screenSize, true)}>
        <div className="w-full relative flex flex-col sm:flex-row justify-between items-start pl-4 pr-36 sm:pr-52 sm:pl-5 py-4 sm:py-5 lg:py-[27px] xxl:py-8">
          <img src={plusLogoLink} alt="Plus Logo" className="self-start pb-2 h-5 sm:self-center sm:pb-0 sm:h-8 lg:h-10 xxl:h-[50px]" />
          <div className="relative flex flex-col ml-0 md:flex-row md:justify-between lg:flex-col lz:flex-row w-full pl-0 sm:pl-4 lg:pl-5">
            <div className="w-full">
              <h4 className="text-gray-900 text-base sm:text-xl md:text-2xl font-bold m-0 pb-1 !leading-none">
                Unlock FREE &amp; Priority Shipping with Plus!
              </h4>
              <p className="text-gray-800 text-xs my-0 sm:text-sm md:text-base lg:text-lg !leading-none">
                Get free shipping, member discounts, guaranteed savings, & more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </tracking.a>;
};
export default WebPlusShippingAdLoggedOut;